import React from 'react';

const Vue_Component_Instance_props = () => {
  return (
    <div>
      <h1>Vue_Component_Instance_props Component</h1>
      <p>This is the Vue_Component_Instance_props tutorial page.</p>
    </div>
  );
}

export default Vue_Component_Instance_props;
